import { render, staticRenderFns } from "./AssistantServiceEdit.vue?vue&type=template&id=3104a7bc"
import script from "./AssistantServiceEdit.vue?vue&type=script&lang=js"
export * from "./AssistantServiceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports